import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';
// import { v4 as uuidv4 } from 'uuid';

const stateCarousel = 'S2';

export const useBroadcast = () => {
  const { user, carousel, repeatCount, startFrom, duration } = useGetParams();

  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [currentMessage, setCurrentMessage] = useState(null);

  const lastMessageIdRef = useRef(0);
  const nextMessageIndexRef = useRef(-1);
  const messagesRef = useRef([]);

  const [winnerMessages, setWinnerMessages] = useState([]);
  const messagesWinnerRef = useRef([]);

  const rotate = useRef('-');

  // задержка интервала смены сообщений
  const [delay, setDelay] = useState(duration);
  // id предыдущего запущенного интерактива
  const prevIdBroadcast = useRef('');
  // id текущего запущенного интерактива
  const iactiveIdRef = useRef('');

  const protocol = window?.location?.protocol || 'https:';

  const createImage = (url) => {
    const img = document.createElement('img');
    img.src = url;
    return img;
  };

  const getBroadcastInfo = async () => {
    if (!user) {
      return;
    }

    try {
      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();

      if (!data) return;

      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // очистка при остановке\смене интерактива, при остановке iactiveId = ""
      if (iactiveIdRef.current !== iactiveId) {
        if (
          currentMessage &&
          iactiveId &&
          iactiveId !== prevIdBroadcast.current // если === , значит prevIdBroadcast был остановлен и теперь запущен, и не нужно обнулять
        ) {
          messagesRef.current = [];
          messagesWinnerRef.current = [];
          setCurrentMessage(null);
          setWinnerMessages([]);
          nextMessageIndexRef.current = -1;
        }
      }

      // сохранение id нового запущенного интерактива.
      if (iactiveId && iactiveId !== prevIdBroadcast.current) {
        // Если уже был предыдущий запущенный интерактив, то показать сообщение сразу без задержки.
        if (prevIdBroadcast.current) {
          // console.log('смена интреактива');
          setDelay(0);
        }
        prevIdBroadcast.current = iactiveId;
      }

      // Определяем видимость титра
      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)
      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        setCurrentState(getActiveState(data?.statusList[0].state));
      }

      // если список сообщений пустой
      if (
        !messagesList ||
        (Array.isArray(messagesList) && messagesList.length === 0)
      ) {
        // удаляем победителей
        if (
          winnerMessages.some((item) =>
            deletedMessagesIdList.includes(Number(item.id)),
          )
        ) {
          setWinnerMessages(
            winnerMessages.filter(
              (item) => !deletedMessagesIdList.includes(Number(item.id)),
            ),
          );

          messagesWinnerRef.current = messagesWinnerRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );
        }

        // если имеются в списке сообщений удаленные
        if (
          messagesRef.current.some((el) =>
            deletedMessagesIdList.includes(+el.id),
          )
        ) {
          const newState = messagesRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );

          for (let i = 0; i < messagesRef.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRef.current &&
                  el.id ===
                    messagesRef.current[nextMessageIndexRef.current]?.id,
              )
            ) {
              if (
                messagesRef.current[nextMessageIndexRef.current] ===
                messagesRef.current[messagesRef.current.length - 1]
              ) {
                nextMessageIndexRef.current--;
                if (nextMessageIndexRef.current < 0)
                  nextMessageIndexRef.current = 0;
              }
            }
            if (
              i < nextMessageIndexRef.current &&
              !newState.find((el) => el.id === messagesRef.current[i].id)
            ) {
              nextMessageIndexRef.current--;
              if (nextMessageIndexRef.current < 0)
                nextMessageIndexRef.current = 0;
            }
          }

          messagesRef.current = newState;
        }

        //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов

        if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
          lastMessageIdRef.current = 0;
          iactiveIdRef.current = iactiveId;
          return;
        } else {
          iactiveIdRef.current = iactiveId;
          lastMessageIdRef.current =
            messagesList[0]?.id || lastMessageIdRef.current;
        }
        return;
      }

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      // оставляем только сообщения с вложениями с типом image
      messagesList = messagesList.filter(
        (el) =>
          Array.isArray(el.message.attachments) &&
          el.message.attachments.length > 0 &&
          typeof el.message.attachments[0] === 'object' &&
          el.message.attachments[0].type === 'image',
      );

      messagesList.slice(0, repeatCount).forEach((el, i) => {
        let { attachments, image } = el.message;
        if (
          typeof attachments === 'string' &&
          attachments.replace(/&quot;/g, '"') !== ''
        ) {
          attachments = JSON.parse(attachments.replace(/&quot;/g, '"'));
        }

        if (attachments && attachments[0]) {
          const url = attachments[0].url;
          document.getElementById('img-loader')?.appendChild(createImage(url));
        }

        if (image && image !== '1') {
          document
            .getElementById('img-loader')
            ?.appendChild(createImage(image));
        }
      });

      const msgF1 = messagesList.filter((el) => el.titrTag === 'F1');
      const msgF2 = messagesList.filter((el) => el.titrTag === 'F2');

      let result = [];
      msgF1.forEach((el) => {
        if (
          typeof el.message?.attachments?.[0] === 'object' &&
          el.message?.attachments?.[0]?.url &&
          !messagesRef.current.find(
            (elm) =>
              typeof elm.message.attachments?.[0] === 'object' &&
              typeof el.message.attachments?.[0] === 'object' &&
              elm.message.attachments?.[0]?.url ===
                el.message.attachments?.[0]?.url,
          )
        ) {
          result.push(el);
        } else if (
          !messagesRef.current.find(
            (elm) =>
              elm.message.content === el.message.content &&
              elm.message.author === el.message.author &&
              elm.titrTag === el.titrTag,
          )
        ) {
          result.push(el);
        }
      });

      messagesRef.current = [...messagesRef.current, ...result.reverse()].slice(
        -repeatCount,
      );

      // победители
      let winners = msgF2.filter(
        (el) => !messagesWinnerRef.current?.find((win) => win.id === el.id),
      );

      messagesWinnerRef.current = [
        ...messagesWinnerRef.current,
        ...winners.reverse(),
      ];

      setWinnerMessages((prev) => [...winners.reverse(), ...prev]);
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);
          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);

        // наклон фото в сообщении
        // if (rotate.current === '+') {
        //   rotate.current = '-';
        // } else {
        //   rotate.current = '+';
        // }

        let currentMsg = {
          ...messagesRef.current[nextMessageIndexRef.current],
          rotateSign: rotate.current,
        };
        setCurrentMessage(currentMsg);
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(
    () => {
      iterateIndex(messagesRef.current);
      if (
        messagesRef.current &&
        messagesRef.current.length === 0 &&
        currentMessage !== null
      ) {
        setCurrentMessage(null);
      } else if (
        messagesRef.current &&
        messagesRef.current.length > 0 &&
        (!currentMessage ||
          (currentMessage &&
            currentMessage.id !==
              messagesRef.current[nextMessageIndexRef.current].id))
      ) {
        // наклон фото в сообщении
        // if (rotate.current === '+') {
        //   rotate.current = '-';
        // } else {
        //   rotate.current = '+';
        // }

        setCurrentMessage({
          ...messagesRef.current[nextMessageIndexRef.current],
          rotateSign: rotate.current,
        });

        // добавление задержки интервалу, после отработки по нулевой задержке (delay === 0)
        if (delay === 0) {
          setDelay(duration);
        }
      }
    },
    isVisible && currentState === stateCarousel ? delay : null,
  );

  // Получение информации о титре
  useInterval(getBroadcastInfo, 1000);

  return {
    currentState,
    isVisible,
    currentMessage,
    winnerMessages,
    stateCarousel,
  };
};
